/**
 * custom-loncheado.js
 * - Muestra el label del servicio desde metacampo (robusto: .value y raw)
 * - Fallback: autocompleta con el precio de la variante del servicio
 * - Añade producto + servicio evitando duplicados y respetando carrito existente
 */

document.addEventListener('DOMContentLoaded', () => {
  // ---- Localizar elementos del formulario de producto (Dawn y similares) ----
  const productFormEl =
    document.querySelector('product-form') ||
    document.querySelector('[data-type="add-to-cart-form"]'); // fallback

  const form =
    (productFormEl && productFormEl.querySelector('form')) ||
    document.querySelector('form[action*="/cart/add"]');

  const checkbox = document.getElementById('loncheado-checkbox');
  if (!form || !checkbox) return; // En esta PDP no hay servicio configurado

  // ---- Pintar el texto del label (lee metacampo .value y raw) ----
  (function paintLoncheadoLabel() {
    const labelSpan = document.querySelector('.loncheado-label');
    if (!labelSpan) return;
// Si el span ya trae texto desde Liquid (metacampo), no lo toques
const currentFromSpan = (labelSpan.textContent || '').trim();
if (currentFromSpan) return;

const txtVal   = (checkbox.getAttribute('data-text-val')   || '').trim();
const txtRaw   = (checkbox.getAttribute('data-text-raw')   || '').trim();
const txtFinal = (checkbox.getAttribute('data-text-final') || '').trim();
const baseText = txtVal || txtRaw || txtFinal;
    if (baseText) {
      // Si el metacampo existe (en cualquiera de sus variantes), úsalo
      labelSpan.textContent = baseText;
      return;
    }

    // Fallback: si no hay texto, autocompletar con el precio del servicio
    const idFromDom = checkbox.getAttribute('data-loncheado-id');
    const LONCHEADO_VARIANT_ID = idFromDom ? parseInt(idFromDom, 10) : null;
    if (!LONCHEADO_VARIANT_ID) { labelSpan.textContent = '¿Cortamos?'; return; }

    fetch(`/variants/${LONCHEADO_VARIANT_ID}.json`)
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        const p = data?.variant?.price;
        if (!p) { labelSpan.textContent = 'Click aquí, si lo quieres loncheado'; return; }
        const euros = Number(p);
        const formatted = euros.toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
        labelSpan.textContent = `Click aquí, si lo quires loncheado +${formatted}`;
      })
      .catch(() => { labelSpan.textContent = 'Click aquí, si lo quieres loncheado'; });
  })();
  // ---- Helpers de carrito ----
  async function getCart() {
    const r = await fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } });
    return r.json();
  }
  async function addItems(items) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  }
  // ---- Envío: interceptar antes que Dawn para evitar duplicados ----
  let submitting = false;
  async function handleAdd(e) {
    // Si no marcan loncheado, dejamos flujo nativo
    if (!checkbox.checked) { submitting = false; return; }

    // Evitar dobles ejecuciones
    if (submitting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    submitting = true;

    // Bloquear submit nativo y handlers del tema
    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      const fd = new FormData(form);
      const mainVariantId = Number(fd.get('id'));
      const qtyWanted = Number(fd.get('quantity') || 1);

      const idFromDom = checkbox.getAttribute('data-loncheado-id');
      const LONCHEADO_VARIANT_ID = idFromDom ? parseInt(idFromDom, 10) : null;
      if (!LONCHEADO_VARIANT_ID) throw new Error('ID del servicio no disponible');

      // ¿ya está el producto principal en el carrito?
      const cart = await getCart();
      const existing = cart.items.find(li => li.id === mainVariantId);
      const existingQty = existing ? existing.quantity : 0;

      if (existingQty > 0) {
        // Añadir solo el servicio por la cantidad existente
        await addItems([{
          id: LONCHEADO_VARIANT_ID,
          quantity: existingQty,
          properties: { Servicio: 'Loncheado', Parent: String(mainVariantId) }
        }]);
      } else {
        // Añadir producto y servicio (dos pasos, robusto)
        await addItems([{ id: mainVariantId, quantity: qtyWanted }]);
        await addItems([{
          id: LONCHEADO_VARIANT_ID,
          quantity: qtyWanted,
          properties: { Servicio: 'Loncheado', Parent: String(mainVariantId) }
        }]);
      }

      // Ir al carrito (ajusta si usas drawer)
      window.location.href = '/cart';
    } catch (err) {
      alert('No se pudo añadir al carrito.\n\nDetalle: ' + (err?.message || err));
      // No re-enviamos el form para evitar duplicados
      window.location.href = '/cart';
    } finally {
      submitting = false;
    }
  }

  // Interceptar submit en captura en <product-form> y en el <form> interno
  if (productFormEl) productFormEl.addEventListener('submit', handleAdd, { capture: true });
  form.addEventListener('submit', handleAdd, { capture: true });

  // Bloquear click del botón si hay loncheado marcado (por si algún script dispara click)
  const submitBtn =
    form.querySelector('[type="submit"]') ||
    form.querySelector('button[name="add"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', (e) => {
      if (checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }, { capture: true });
  }
});
